// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__aiEEX","title":"FrontImage_title__2PUtc"};